import axios from 'axios';

import env from '~/env';
import { injectAccessTokenInterceptor, refreshTokenResponseInterceptor }
  from '~/services/keycloack-api/keycloack-api.interceptors';

const installationRiskHttp = axios.create({
  baseURL: env.VITE_INSTALLATION_RISK_API_URL,
});

installationRiskHttp.interceptors.request.use(injectAccessTokenInterceptor);
installationRiskHttp.interceptors.response.use((c) => c, refreshTokenResponseInterceptor);

export default installationRiskHttp;
